import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs/operators';
import { authCheckedSignal, currentUserSignal } from '../../state/auth.state';
import {
  clienteContextoCargadoSignal,
  clientesDisponiblesSignal
} from '../../compartidos/services/client-context.state';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);

  return toObservable(authCheckedSignal).pipe(
    filter((ready) => ready === true), // esperar que Firebase haya respondido
    take(1), // solo nos interesa una vez
    map(() => {

      const user = currentUserSignal();
      if (user) {
        return true;
      } else {
        router.navigate(['/login']);
        return false;
      }
    })
  );
};

/**
 * Exige que el usuario tenga al menos un cliente permitido en Usuarios_Clientes.
 *
 * Sin esto, un usuario autenticado pero sin clientes asignados entraría a un
 * dashboard vacío sin explicación: el center saldría null y ningún módulo
 * cargaría datos.
 *
 * Este guard resuelve DÓNDE puede trabajar, no QUÉ puede hacer:
 * los permisos siguen siendo una dimensión independiente.
 */
export const clientContextGuard: CanActivateFn = () => {
  const router = inject(Router);

  return toObservable(clienteContextoCargadoSignal).pipe(
    filter((cargado) => cargado === true),
    take(1),
    map(() => {

      if (clientesDisponiblesSignal().length > 0) {
        return true;
      }

      router.navigate(['/sin-acceso']);
      return false;
    })
  );
};
